import type { AdminMembership, MembershipRole } from "@/shared/organizations/membership-types";

export interface MembershipSummary {
  readonly total: number;
  readonly active: number;
  readonly inactive: number;
  readonly byRole: Readonly<Record<MembershipRole, number>>;
}

const EMPTY_BY_ROLE: Readonly<Record<MembershipRole, number>> = { OWNER: 0, ADMIN: 0, STAFF: 0 };

/** Counts a user's memberships by status and role, for the card's header line. */
export function summarizeMemberships(memberships: readonly AdminMembership[]): MembershipSummary {
  return memberships.reduce<MembershipSummary>(
    (summary, m) => ({
      total: summary.total + 1,
      active: summary.active + (m.status === "ACTIVE" ? 1 : 0),
      inactive: summary.inactive + (m.status === "ACTIVE" ? 0 : 1),
      // A role this UI does not know still counts in the total, never as NaN.
      byRole:
        m.role in summary.byRole
          ? { ...summary.byRole, [m.role]: summary.byRole[m.role] + 1 }
          : summary.byRole,
    }),
    { total: 0, active: 0, inactive: 0, byRole: EMPTY_BY_ROLE },
  );
}
